// Role-independent deep-link target for Live-tab notifications
// (message.url = /live/{tournamentId}). Stores the tournament to preselect
// and forwards to the user's own page, where Live is the default first tab.

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFirebase } from '../components/FirebaseContextProvider';
import { getBaseRoute } from '../components/LoginCard';
import { storageLiveTournament } from '../utils/consts';

export default function PageLive() {
  const { tournamentId } = useParams();
  const { user } = useFirebase();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (tournamentId)
      sessionStorage.setItem(storageLiveTournament, tournamentId);
    navigate(`${getBaseRoute(user)}#live`, { replace: true });
  }, [user, tournamentId, navigate]);

  return null;
}
